import { Box, Text } from "@whoosh/design-system/src/components/primitive";
import { WhooshThemeColors } from "@whoosh/design-system/src/theme/restyle/theme";

type Props = {
  bodyTitle?: string;
  bodyContent?: string;
  titleColor?: WhooshThemeColors;
  bodyColor?: WhooshThemeColors;
};

export const TimeListInfoCardBody = ({
  bodyTitle,
  bodyContent,
  titleColor,
  bodyColor,
}: Props) => {
  return (
    <Box mt={4}>
      {bodyTitle?.length ? (
        <Text variant="mainBaseSemiBold" color={titleColor}>
          {bodyTitle || ""}
        </Text>
      ) : null}
      {bodyContent?.length ? (
        <Text
          pt={bodyTitle?.length ? 2 : 0}
          variant="mainBaseMedium"
          color={bodyColor}
        >
          {bodyContent || ""}
        </Text>
      ) : null}
    </Box>
  );
};
